// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"19":"10357fe1","51":"1f71200e","58":"65736e7b","373":"32af7fbe","493":"3c905ca6","503":"c09cd599","561":"37c36941","681":"2e3e6f59","980":"33fa5b82"}[chunkId] + ".js";
};